import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { WalletService } from './wallet.service';
import { PricingService } from './pricing.service';
import { ShipmentsService } from './shipments.service';
import { UsersService } from './users.service';
import { clients } from '../utils/interceptors';

class _ApiService {
  client = clients.common;
  pricing = clients.pricing;
  wallet = clients.wallet;
  AuthService = new AuthService(this.client, this.pricing);
  WalletService = new WalletService(this.client, this.pricing, this.wallet);
  ConfigService = new ConfigService(this.client, this.pricing);
  PricingService = new PricingService(this.client, this.pricing);
  ShipmentsService = new ShipmentsService(this.client, this.pricing);
  UsersService = new UsersService(this.client, this.pricing);
  constructor(client, pricing, wallet) {
    this.client.defaults.baseURL = client;
    this.pricing.defaults.baseURL = pricing;
    this.wallet.defaults.baseURL = wallet;
  }
}

const { REACT_APP_CI_COMMIT_REF_NAME } = process.env;

const integrationServices =
  REACT_APP_CI_COMMIT_REF_NAME === 'prod'
    ? 'https://api.shipal.co'
    : 'https://devapi.shipal.co';
const pricingServices =
  REACT_APP_CI_COMMIT_REF_NAME === 'prod'
    ? 'https://pricing.shipal.co'
    : 'https://pricing-dev.shipal.co';
const walletServices =
  REACT_APP_CI_COMMIT_REF_NAME === 'prod'
    ? 'https://3b9y3fsku1.execute-api.us-east-1.amazonaws.com/prod'
    : 'https://t1eqxkcvb6.execute-api.us-east-1.amazonaws.com/dev';

export const ApiService = new _ApiService(
  integrationServices,
  pricingServices,
  walletServices //
);
